// Display code shown for a client, matching the CLT-001 convention used by the
// client list.
export const clientCode = (id) => `CLT-${String(id).padStart(3, "0")}`;

// Companies go by their company name; individuals by their primary user.
export const clientName = (client) => {
  if (!client) return "—";
  if (client.type === "Company") return client.company_name || "—";

  const primary = client.primary_user || {};
  const fullName = `${primary.first_name || ""} ${primary.last_name || ""}`.trim();
  return fullName || client.company_name || "—";
};
